import { Injectable } from '@angular/core';
@Injectable()
export class AuthService {

  /* SET values in local storage */
  /* Ashok - Code optimization is pending */
  public setToken(token: string) {
    localStorage.setItem('AuthToken', token);
  }
  public setUserName(userName: string) {
    localStorage.setItem('UserName', userName);
  }
  public setCompanyId(id: string) {
    localStorage.setItem('CompanyId', id)
  }
  public setUserId(id: string) {
    localStorage.setItem('UserId', id)
  }
  public setUnAuthorizedList(list: string) {
    localStorage.setItem('UnAuthorizedList', list)
  }
  public setUserTimeZone(timeZone: any) {
    localStorage.setItem('TimeZoneInfo', timeZone);
  }
  public setUserPlan(val: string) {
    localStorage.setItem('Version', val);
  }
  public setCompanyQBType(val: string) {
    localStorage.setItem('QBVersion', val);
  }
  public setCreditPaymentAllowed(val: string) {
    localStorage.setItem('CcPayAllowed', val);
  }
  public setAppInfo(val: any) {
    localStorage.setItem('AppInfo', JSON.stringify(val));
  }

  /* GET values from local storage */
  public getCompanyId(): string {
    return localStorage.getItem('CompanyId');
  }
  public getToken(): string {
    return localStorage.getItem('AuthToken');
  }
  public getUserTimeZone(): any {
    return localStorage.getItem('TimeZoneInfo');
  }
  public getUserPlan(): any {
    return localStorage.getItem('Version');
  }
  public getCompanyQBType() {
    return (this.isNullOrEmptyOrUndefined(localStorage.getItem('QBVersion'), false) ? "None" : localStorage.getItem('QBVersion'));
  }
  public getLoggedUserName() {
    return localStorage.getItem("UserName");
  }
  public getCreditPaymentAllowed() {
    return JSON.parse(localStorage.getItem('CcPayAllowed'));
  }
  public getAppInfo() {
    return JSON.parse(localStorage.getItem('AppInfo'));
  }
  public getUserId() {
    return localStorage.getItem('UserId');
  }
  /* Clear values from local storage */
  public clearStorage() {
    localStorage.clear();
  }

  /**
 * Checks value is null or undefined or empty
 * Created locally to prevent cicular dependency on common methods i.e. auth->common->timezone->auth
 * @param val input value
 * @param isEmptyCheck checks only when true
 */
  public isNullOrEmptyOrUndefined(val: any, isEmptyCheck: boolean) {
    return (val == undefined || val == null || (val == "" && isEmptyCheck)) ? true : false;
  }
}